"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Thevemarkpromise() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: specsRef,
    isVisible: specsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const specs = [];
  const paragraphs = ["We founded our engraving workshop with a singular focus on industrial durability. Our facility was built on the principle that identification markers should outlast the equipment they protect. We serve engineers and contractors who demand precision, not just aesthetics. Two decades later, our commitment to technical accuracy remains our primary driver.", "Every order begins with a rigorous review of your specifications and ends with a component that meets the highest industry standards. We utilize advanced laser technology and high-grade materials to ensure legibility and longevity. We verify every detail, consult with your project leads, and deliver solutions that stand the test of time.", "If you require generic labeling, there are many options available. If you require precision-engineered identification that complies with strict regulatory requirements, partner with us. We are available to discuss your technical specifications Monday through Friday, eight to five."];
  return <section data-section-id="1735" id="thevemarkpromise" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        {}
        <div ref={headRef} className={`flex items-center justify-center gap-3 mb-12 md:mb-16 transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <span className="font-mono uppercase tracking-[0.18em] text-xs md:text-sm" style={{
          color: "var(--accent)"
        }}>
            W.O. No 02
          </span>
          <span className="inline-block w-2 h-2" style={{
          backgroundColor: "var(--accent)"
        }} aria-hidden="true" />
          <span className="font-mono uppercase tracking-[0.18em] text-xs md:text-sm" style={{
          color: "var(--accent)"
        }}>
            OUR PROMISE
          </span>
        </div>

        {}
        <h2 className="font-default font-black uppercase text-left transition-all duration-700 ease-out opacity-100 translate-y-0 text-primary" style={{
        fontSize: "clamp(2.5rem, 5.5vw, 5.25rem)",
        lineHeight: "0.95",
        letterSpacing: "-0.03em",
        transitionDelay: "120ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          WE BELIEVE MARKINGS
          <br />
          SHOULD BE{" "}
          <span className="relative inline-block whitespace-nowrap">
            <span className="relative z-10">PERMANENT</span>
            <svg className="absolute left-[-4%] top-1/2 -translate-y-1/2 pointer-events-none" width="108%" height="120%" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <line x1="0" y1="80" x2="100" y2="20" stroke="var(--accent)" strokeWidth="8" style={{
              strokeDasharray: 200,
              strokeDashoffset: headVisible ? 0 : 200,
              transition: "stroke-dashoffset 700ms cubic-bezier(0.22, 1, 0.36, 1) 700ms"
            }} />
            </svg>
          </span>
          .
          <br />
          ACCURATE FIRST.
          <br />
          DURABLE BECAUSE
          <br />
          THEY ARE ENGINEERED.
        </h2>

        {}
        <div className={`mt-14 md:mt-20 mb-12 md:mb-16 flex items-center transition-opacity duration-500 ${headVisible ? "opacity-100" : "opacity-0"}`} style={{
        transitionDelay: "400ms"
      }}>
          <div className="flex-1 h-px" style={{
          backgroundColor: "var(--accent)"
        }} />
          <div className="w-1.5 h-1.5" style={{
          backgroundColor: "var(--accent)"
        }} aria-hidden="true" />
        </div>

        {}
        <div ref={bodyRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          <div className={`md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 transition-all duration-700 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            {paragraphs.map((p, i) => <p data-index={i} key={i} className={`font-default text-base md:text-lg leading-[1.6] text-foreground/85 ${i === 0 ? "md:col-span-1" : i === 1 ? "md:col-span-1" : "md:col-span-2 max-w-3xl"}`} style={{
            transitionDelay: `${i * 80}ms`
          }}>
                {p}
              </p>)}
          </div>
        </div>

        {}
        <div ref={specsRef} className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-3">
          {specs.map((spec, i) => <div data-index={i} key={i} className={`relative p-6 md:p-7 transition-all duration-600 ease-out ${specsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          backgroundColor: "var(--card)",
          transitionDelay: `${i * 80}ms`,
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
              {}
              <div className="absolute top-0 left-0 right-0 h-px" style={{
            backgroundColor: "var(--accent)"
          }} aria-hidden="true" />
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="font-default font-black uppercase text-foreground leading-none" style={{
              fontSize: "clamp(2rem, 3.5vw, 3rem)",
              letterSpacing: "-0.03em"
            }}>
                  {spec.value}
                </span>
                {spec.unit && <span className="font-mono uppercase text-xs tracking-[0.12em]" style={{
              color: "var(--accent)"
            }}>
                    {spec.unit}
                  </span>}
              </div>
              <div className="mt-4 font-mono uppercase text-[11px] md:text-xs tracking-[0.14em] text-foreground/65">
                {spec.label}
              </div>
            </div>)}
        </div>

        {}
        <div className={`mt-16 md:mt-20 flex justify-center transition-all duration-700 ease-out ${specsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "400ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <Link to="/ProductsPage" className="group inline-flex items-center gap-2 font-default font-bold uppercase tracking-[0.06em] text-sm md:text-base" style={{
          color: "var(--accent)"
        }}>
            <span className="relative">
              <span className="relative z-10">VIEW OUR CAPABILITIES</span>
              <span className="absolute left-0 right-0 bottom-[2px] h-[2px] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" style={{
              backgroundColor: "var(--accent)"
            }} aria-hidden="true" />
            </span>
            <span className="inline-block transition-transform duration-300 ease-out group-hover:translate-x-1.5" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </div>
    </section>;
}